(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["setsugekka-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.sg-home:not([data-ready])').forEach((section) => {
      section.dataset.ready = 'true';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const revealItems = section.querySelectorAll('[data-sg-reveal]');
      const parallaxItems = section.querySelectorAll('[data-sg-parallax]');
      const hero = section.querySelector('[data-sg-hero]');
      const heroStage = hero ? hero.querySelector('.sg-home__hero-stage') : null;
      const linkedGroup = section.querySelector('.sg-home__hero-subtitle-group');
      const alignLinkedSubtitle = () => {
        if (!linkedGroup) return;
        const introText = document.querySelector('.setsugekka-intro:not(.is-hidden) .setsugekka-intro__message');
        const heroText = linkedGroup.querySelector('[data-setsugekka-linked-subtitle]');
        if (!introText || !heroText) return;

        /* Reset first, then compare the two rendered text boxes themselves. This remains
           exact even when Atelier's header, theme editor chrome, or a later stylesheet
           changes the containing block used by either section. */
        linkedGroup.style.setProperty('--sg-linked-align-x', '0px');
        linkedGroup.style.setProperty('--sg-linked-align-y', '0px');
        const introRect = introText.getBoundingClientRect();
        const heroRect = heroText.getBoundingClientRect();
        linkedGroup.style.setProperty('--sg-linked-align-x', `${introRect.left - heroRect.left}px`);
        linkedGroup.style.setProperty('--sg-linked-align-y', `${introRect.top - heroRect.top}px`);
      };
      requestAnimationFrame(() => requestAnimationFrame(alignLinkedSubtitle));
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => requestAnimationFrame(alignLinkedSubtitle));
      window.addEventListener('resize', () => requestAnimationFrame(alignLinkedSubtitle), { passive: true });
      if (reduceMotion) { revealItems.forEach((item) => item.classList.add('is-visible')); return; }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: .12 });
      revealItems.forEach((item) => observer.observe(item));

      let ticking = false;
      const updateParallax = () => {
        if (hero) {
          const heroRect = hero.getBoundingClientRect();
          const holdDistance = (Number.parseFloat(section.dataset.sgHeroHold) || 0) * window.innerHeight / 100;
          const fadeDistance = Math.max((Number.parseFloat(section.dataset.sgHeroTransition) || 80) * window.innerHeight / 100, 1);
          const distance = holdDistance + fadeDistance;
          const scrolled = Math.min(distance, Math.max(0, -heroRect.top));
          const progress = Math.min(1, Math.max(0, (scrolled - holdDistance) / fadeDistance));
          hero.style.setProperty('--sg-hero-progress', progress.toFixed(4));
          if (heroStage) {
            /* The hero is a normal document section: it must be able to leave
               the viewport completely instead of being pinned in place. */
            heroStage.style.transform = 'none';
            heroStage.style.opacity = '1';
          }
        }
        parallaxItems.forEach((item) => {
          const rect = item.getBoundingClientRect();
          const speed = Number.parseFloat(item.dataset.sgParallax) || 0;
          item.style.transform = `translate3d(0, ${(rect.top + rect.height / 2 - window.innerHeight / 2) * speed}px, 0)`;
        });
        ticking = false;
      };
      window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(updateParallax); ticking = true; } }, { passive: true });
      updateParallax();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["setsugekka-intro"]) return;
  try {
    
  (() => {
    const intros = document.querySelectorAll('.setsugekka-intro:not([data-ready])');
    intros.forEach((intro) => {
      intro.dataset.ready = 'true';
      const showOnce = intro.dataset.showOnce === 'true';
      const handoffToHero = intro.dataset.handoffToHero !== 'false';
      const message = intro.querySelector('.setsugekka-intro__message');
      const root = document.documentElement;
      if (message) message.dataset.plainText = message.textContent || '';

      /* The existing Hero SUBTITLE is the handoff target.
         It uses the exact same shared CSS variables/classes as the intro text.
         Only the text content is synchronized here; font, size and position are
         not copied/calculated in JavaScript, so both always use one system. */
      const syncHeroSubtitle = () => {
        if (!handoffToHero || !message) return null;
        const subtitle = document.querySelector('[data-setsugekka-linked-subtitle]');
        if (!subtitle) return null;
        subtitle.textContent = message.dataset.plainText || message.textContent || '';
        return subtitle;
      };

      /* Sync before the show-once check so the hero heading never disappears on reload. */
      syncHeroSubtitle();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHeroSubtitle);
      window.addEventListener('resize', syncHeroSubtitle, { passive: true });

      let hasSeen = false;
      try { hasSeen = sessionStorage.getItem('setsugekka-intro-seen') === 'true'; } catch (error) { hasSeen = false; }
      if (showOnce && hasSeen) {
        intro.classList.add('is-hidden');
        intro.setAttribute('aria-hidden', 'true');
        return;
      }

      const duration = Math.max(1200, Number.parseInt(intro.dataset.duration, 10) || 2600);
      const fadeDuration = Math.max(1400, Number.parseInt(intro.dataset.fadeDuration, 10) || 2400);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        intro.classList.add('is-hidden');
        intro.setAttribute('aria-hidden', 'true');
        return;
      }

      if (message) {
        const text = message.textContent;
        message.dataset.originalText = text;
        message.textContent = '';
        Array.from(text).forEach((character, index) => {
          const span = document.createElement('span');
          span.className = 'setsugekka-intro__character';
          span.style.setProperty('--character-index', index);
          span.textContent = character;
          span.setAttribute('aria-hidden', 'true');
          message.appendChild(span);
        });
      }

      root.dataset.setsugekkaIntroActive = 'true';
      window.setTimeout(() => {
        try { sessionStorage.setItem('setsugekka-intro-seen', 'true'); } catch (error) {}
        syncHeroSubtitle();
        if (message) message.style.opacity = '0';
        intro.classList.add('is-leaving');
        intro.setAttribute('aria-hidden', 'true');
        window.setTimeout(() => {
          intro.remove();
          delete root.dataset.setsugekkaIntroActive;
        }, fadeDuration + 100);
      }, duration);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
